import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../global.css"
import { useRef } from "react";



export default function LatestVideo({ homeData }) {
  const sliderRef = useRef(null);
  const settings = {
     infinite: true, // loop: true
    slidesToShow: 2, // default
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000, // autoplayTimeout
    speed: 550, // smartSpeed
    pauseOnHover: true, // autoplayHoverPause
    dots: false,
    arrows: false, // nav: true
    responsive: [
      {
        breakpoint: 1000, // <=1000px
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 500, // <=500px
        settings: { slidesToShow: 1, slidesToScroll: 1 },
      },
    ],
  };

  return (
    <>
    <Slider ref={sliderRef} {...settings}>
      {homeData?.testimonial &&
        homeData.testimonial.map((item, index) =>
          item?.formType === "Testimonial" ? (
            <div className="item"  key={index}>
                    <div className="videotesti-cont">
                     <video
                      width="100%"
                      height="200"
                      controls
                      controlsList="nodownload"
                      disablePictureInPicture
                      onContextMenu={(e) => e.preventDefault()}
                    >
                      <source
                        src={`${process.env.REACT_APP_BASE_URL_API}${item.image_video}`}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>

                    </div>
            </div>
               ) : null
          )}
            

              
    </Slider>
    
    <div className="owl-nav-latest">
      <button onClick={() => sliderRef.current.slickPrev()} type="button" role="presentation" className="owl-prev"><i className="fa-solid fa-angle-left"></i></button>
      <button onClick={() => sliderRef.current.slickNext()} type="button" role="presentation" className="owl-next"><i className="fa-solid fa-angle-right"></i></button>
      </div>
    
      </>
  );
}
